enum UploadStatus {
	INITIAL = 'INITIAL',
	UPLOADING = 'UPLOADING',
	SUCCESS = 'SUCCESS',
	FAILURE = 'FAILURE'
}

export default UploadStatus;
